import { Pipe, PipeTransform, Injectable, inject } from '@angular/core';
import AngularHelperService from '../services/angular-helper.service';

@Pipe({ name: 'unreadChats', standalone: true })
@Injectable({providedIn: 'root'})
export class UnreadChatsPipe implements PipeTransform {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	transform(chats) {
		var unreadChats: any = {};
		this.angularHelperService.forEach(chats, function(chat) {
			if (!chat.lastSeenPostId || (chat.lastPost.id > chat.lastSeenPostId)) {
				unreadChats[chat.id] = chat;
			}
		});
		return unreadChats;
	}
	
}